import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DraggableTableRow } from './interfaces/draggable-table-row';

@Component({
    selector: 'sera-draggable-table',
    templateUrl: './sera-draggable-table.component.html',
    styleUrls: ['./sera-draggable-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraDraggableTableComponent implements OnInit, OnChanges {
    @Input()
    rowList: DraggableTableRow[] = [];

    @Input()
    nonDraggableCount?: number;

    @Input()
    showSelectAll?: boolean = true;

    @Input()
    inputStyle: string = '';

    @Output()
    draggableTableStateChanged = new EventEmitter<DraggableTableRow[]>();

    isDragging = false;
    selectAllRows: boolean = false;

    ngOnInit(): void {
        this.draggableTableStateChanged.emit(this.rowList);
    }

    onDrop(event: CdkDragDrop<DraggableTableRow[]>) {
        moveItemInArray(this.rowList, event.previousIndex, event.currentIndex);
        this.draggableTableStateChanged.emit(this.rowList);
    }

    emitSelectOrUnselectedList() {
        this.rowList.forEach(row => (row.isChecked = this.selectAllRows));
        this.draggableTableStateChanged.emit(this.rowList);
    }

    emitUpdatedList() {
        this.draggableTableStateChanged.emit(this.rowList);
        this.changeSelectAllState();
    }

    changeSelectAllState() {
        this.selectAllRows = !this.rowList.some(row => !row.isChecked);
    }

    blockDragBasedOnCondition = (index: number): boolean => {
        return index >= this.nonDraggableCount!;
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.['rowList']?.currentValue?.length > 0) {
            this.changeSelectAllState();
        }
    }
}
